// ============================================
// Google Ads Temel Rehberi - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleAdsTemelRehberContent: BlogContent = {
  tableOfContents: [
    { id: "google-ads-nedir", title: "Google Ads Nedir ve Neden Önemlidir?" },
    { id: "hesap-acma", title: "Google Ads Hesabı Nasıl Açılır?" },
    { id: "kampanya-tipleri", title: "Kampanya Tipleri ve Seçim Kriterleri" },
    { id: "anahtar-kelime", title: "Anahtar Kelime Araştırması ve Seçimi" },
    { id: "butce-yonetimi", title: "Bütçe Yönetimi ve Teklif Stratejileri" },
    { id: "ilk-kampanya", title: "İlk Kampanyanızı Nasıl Başlatırsınız?" },
    { id: "optimizasyon", title: "Kampanya Optimizasyonu İpuçları" }
  ],
  content: [
    { 
      type: "paragraph", 
      value: "<strong>Google Ads</strong>, dijital pazarlamanın en güçlü araçlarından biridir ve doğru kullanıldığında işletmenizin online görünürlüğünü katlanarak artırabilir. Bu <strong>kapsamlı Google Ads rehberi</strong>, sıfırdan başlayarak profesyonel kampanyalar oluşturmanız için gereken tüm bilgileri içermektedir. <strong>18 yıllık deneyimli <a href=\"https://reklam-uzmani.com.tr\" class=\"text-[#059669] font-bold hover:underline\">Google Ads Uzmanı</a></strong> olarak, kampanya kurulumundan optimizasyona kadar tüm süreçleri detaylı şekilde açıklayacağım." 
    },
    
    { type: "heading", value: "Google Ads Nedir ve Neden Önemlidir?", id: "google-ads-nedir" },
    { 
      type: "paragraph", 
      value: "<strong>Google Ads</strong> (eski adıyla <strong>Google AdWords</strong>), Google'ın sunduğu online <strong>reklam platformudur</strong>. Arama sonuçlarında, YouTube'da, Gmail'de ve milyonlarca web sitesinde reklamlarınızı göstermenizi sağlar. <strong>Tıklama başına ödeme (PPC)</strong> modeliyle çalışır, yani sadece reklamlarınıza tıklandığında ödeme yaparsınız." 
    },
    {
      type: "image",
      value: "/images/blog/google-ads-uzmani-dashboard.jpg",
      alt: "Google Ads kampanya dashboard'u ve performans metrikleri",
      caption: "Google Ads hesap yönetim paneli örneği"
    },
    {
      type: "list",
      items: [
        "<strong>Anında görünürlük:</strong> <strong>SEO'nun</strong> aksine, <strong>Google Ads</strong> ile hemen ilk sıralarda yer alabilirsiniz",
        "<strong>Hedefli reklam:</strong> <strong>Demografik, coğrafi ve ilgi alanlarına</strong> göre hassas hedefleme yapabilirsiniz",
        "<strong>Ölçülebilir sonuçlar:</strong> Her <strong>tıklama, görüntüleme ve dönüşümü</strong> detaylı şekilde takip edebilirsiniz",
        "<strong>Esnek bütçe:</strong> Günlük <strong>100₺'den başlayarak</strong> istediğiniz bütçeyle çalışabilirsiniz",
        "<strong>Hızlı ROI:</strong> Doğru kurulumla <strong>ilk haftalarda pozitif yatırım getirisi</strong> elde edebilirsiniz"
      ]
    },
    { type: "heading", value: "Google Ads Hesabı Nasıl Açılır?", id: "hesap-acma" },
    {
      type: "paragraph",
      value: "Google Ads hesabı açmak için aşağıdaki adımları izleyin:"
    },
    {
      type: "list",
      items: [
        "Google Ads web sitesine gidin: <a href=\"https://ads.google.com\" target=\"_blank\" rel=\"noopener noreferrer\">ads.google.com</a>",
        "\"Şimdi Başla\" butonuna tıklayın",
        "Google hesabınızla oturum açın veya yeni bir hesap oluşturun",
        "İşletme bilgilerinizi girin",
        "Ödeme bilgilerinizi ekleyin (henüz reklam yayınlamayacaksınız)",
        "Hesabınız hazır!"
      ]
    },
    { type: "heading", value: "Kampanya Tipleri ve Seçim Kriterleri", id: "kampanya-tipleri" },
    {
      type: "paragraph",
      value: "Google Ads'te birçok farklı kampanya tipi bulunmaktadır. İşletmenizin hedeflerine en uygun olanı seçmek önemlidir:"
    },
    {
      type: "list",
      items: [
        "<strong>Arama Ağı Kampanyaları:</strong> Müşteriler Google'da ürün veya hizmetlerinizi aradığında <strong>reklamlarınızı gösterir</strong>.",
        "<strong>Görüntülü Reklam Ağı Kampanyaları:</strong> <strong>Web sitelerinde, uygulamalarda ve YouTube'da</strong> reklamlarınızı gösterir.",
        "<strong>Video Kampanyaları:</strong> <strong>YouTube'da</strong> ve diğer video platformlarında <strong>video reklamlarınızı</strong> gösterir.",
        "<strong>Alışveriş Kampanyaları:</strong> Ürünlerinizi doğrudan <strong>Google Alışveriş'te</strong> sergiler.",
        "<strong>Uygulama Kampanyaları:</strong> <strong>Uygulamanızı indirmek</strong> isteyen kullanıcılara reklamlarınızı gösterir."
      ]
    },
    { type: "heading", value: "Anahtar Kelime Araştırması ve Seçimi", id: "anahtar-kelime" },
    {
      type: "paragraph",
      value: "<strong>Doğru anahtar kelimeleri seçmek</strong>, Google Ads başarısının temelidir. <strong>Anahtar kelime araştırması</strong> yaparken modern teknikler, AI destekli araçlar ve uzun kuyruk strateji için <a href=\"/blog/keyword-research-2025\" class=\"text-[#059669] font-bold hover:underline\">2025 Keyword Research rehberimize</a> göz atın. Anahtar kelime araştırmasında dikkat edilmesi gerekenler:"
    },
    {
      type: "list",
      items: [
        "<strong>Alaka Düzeyi:</strong> <strong>Anahtar kelimeleriniz</strong>, sunduğunuz <strong>ürün veya hizmetlerle alakalı</strong> olmalıdır.",
        "<strong>Arama Hacmi:</strong> Anahtar kelimelerinizin <strong>yeterli arama hacmi</strong> olmalıdır.",
        "<strong>Rekabet:</strong> Anahtar kelimelerinizin <strong>rekabet düzeyi</strong>, bütçenize uygun olmalıdır.",
        "<strong>Uzun Kuyruklu Kelimeler:</strong> Daha spesifik ve <strong>düşük rekabetli uzun kuyruklu kelimeleri</strong> hedefleyin."
      ]
    },
    { type: "heading", value: "Bütçe Yönetimi ve Teklif Stratejileri", id: "butce-yonetimi" },
    {
      type: "paragraph",
      value: "<strong>Google Ads bütçenizi</strong> doğru yönetmek ve <strong>teklif stratejilerinizi optimize</strong> etmek, <strong>ROI'nizi artırmanın</strong> anahtarıdır. 2025 yılında etkili bütçe planlama ve sektörel bütçe önerileri için <a href=\"/blog/google-ads-budget-2025\" class=\"text-[#059669] font-bold hover:underline\">Google Ads Budget 2025 rehberimizi</a> mutlaka inceleyin:"
    },
    {
      type: "image",
      value: "/images/blog/google-ads-budget-2025.jpg",
      alt: "Google Ads bütçe yönetimi ve optimizasyon stratejileri",
      caption: "Etkili bütçe yönetimi ile ROI artışı"
    },
    {
      type: "list",
      items: [
        "<strong>Günlük Bütçe:</strong> Günlük harcamak istediğiniz <strong>ortalama tutarı</strong> belirleyin.",
        "<strong>Teklif Stratejileri:</strong> <strong>Manuel TBM, Otomatik TBM, Hedef EBM</strong> gibi farklı teklif stratejilerini deneyin.",
        "<strong>Bütçe Optimizasyonu:</strong> <strong>Performansı düşük anahtar kelimeleri</strong> ve reklamları durdurarak bütçenizi optimize edin.",
        "<strong>Dönüşüm İzleme:</strong> <strong>Dönüşüm izleme</strong> ile hangi anahtar kelimelerin ve reklamların işe yaradığını takip edin."
      ]
    },
    { type: "heading", value: "İlk Kampanyanızı Nasıl Başlatırsınız?", id: "ilk-kampanya" },
    {
      type: "paragraph",
      value: "İlk Google Ads kampanyanızı başlatmak için aşağıdaki adımları izleyin:"
    },
    {
      type: "list",
      items: [
        "Google Ads hesabınızda oturum açın.",
        "\"Yeni Kampanya\" butonuna tıklayın.",
        "Kampanya hedefinizi seçin (örneğin, web sitesi trafiği, satışlar, potansiyel müşteriler).",
        "Kampanya tipinizi seçin (örneğin, arama ağı, görüntülü reklam ağı).",
        "Hedefleme ayarlarınızı yapın (örneğin, konum, dil, demografik).",
        "Anahtar kelimelerinizi ve reklam metinlerinizi oluşturun.",
        "Bütçenizi ve teklif stratejinizi belirleyin.",
        "Kampanyanızı yayınlayın."
      ]
    },
    { type: "heading", value: "Kampanya Optimizasyonu İpuçları", id: "optimizasyon" },
    {
      type: "paragraph",
      value: "Google Ads kampanyalarınızı sürekli olarak optimize ederek daha iyi sonuçlar elde edebilirsiniz:"
    },
    {
      type: "list",
      items: [
        "<strong>A/B Testleri:</strong> Farklı <strong>reklam metinleri ve açılış sayfalarıyla A/B testleri</strong> yapın.",
        "<strong>Negatif Anahtar Kelimeler:</strong> <strong>İlgisiz aramalarda</strong> reklamlarınızın gösterilmesini engellemek için <strong>negatif anahtar kelimeler</strong> ekleyin.",
        "<strong>Reklam Uzantıları:</strong> Reklamlarınıza <strong>site bağlantıları, telefon numaraları ve konum bilgileri</strong> ekleyin.",
        "<strong>Mobil Optimizasyon:</strong> <strong>Mobil cihazlar için optimize edilmiş</strong> reklamlar ve açılış sayfaları kullanın.",
        "<strong>Yeniden Pazarlama:</strong> Web sitenizi ziyaret eden kullanıcılara <strong>yeniden pazarlama reklamları</strong> gösterin."
      ]
    }
  ]
};

export default googleAdsTemelRehberContent;
